import type { Gradient } from '@jouzen/ecom-components/v3/RadialGradient';

const activityAndMovementHeroGradients: Gradient[] = [
  {
    shape: 'ellipse',
    hex: '#E0C8AC',
    id: 'orange-1',
    position: [15, 90],
    opacity: 0.8,
    size: 50,
  },
  {
    shape: 'circle',
    hex: '#E0C8AC',
    id: 'orange-2',
    position: [5, 5],
    opacity: 0.6,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#E0C8AC',
    id: 'orange-3',
    position: [90, 45],
    opacity: 0.6,
    size: 30,
  },
];

export default activityAndMovementHeroGradients;
